import {MediaCardType} from '@wandb/weave/common/types/media';
import React from 'react';

import {CustomRunNames} from '../../state/views/customRunNames/types';
import * as PanelTypes from '../../state/views/panel/types';
import {PartRefFromObjSchema} from '../../state/views/types';
import {Axis} from './common';
import PanelTile from './PanelTile';
import {TileWithMaskOptions} from './tiles';

// PanelTileList component for rendering a list of tiles within a group
const PanelTileList = React.memo<{
  tilesToRender: TileWithMaskOptions[];
  tileIndex: number;
  cardWidth: number;
  cardHeight: number;
  config: any;
  mediaType: MediaCardType;
  mediaSliderKey: string;
  labels: Axis[];
  panelRef: PartRefFromObjSchema<PanelTypes.PanelObjSchema>;
  disableRunLinks?: boolean;
  customRunNames?: CustomRunNames;
}>(
  ({
    tilesToRender,
    tileIndex,
    cardWidth,
    cardHeight,
    config,
    mediaType,
    mediaSliderKey,
    labels,
    panelRef,
    disableRunLinks,
    customRunNames,
  }) => {
    return (
      <>
        {tilesToRender.map((tile, index) =>
          tile.isEmpty ? (
            <div
              key={`${tileIndex}-${index}`}
              className="ui card"
              style={{
                width: cardWidth,
                height: cardHeight,
              }}
            />
          ) : (
            <PanelTile
              key={`${tileIndex}-${index}`}
              tile={tile}
              tileIndex={tileIndex}
              cardWidth={cardWidth}
              cardHeight={cardHeight}
              config={config}
              mediaType={mediaType}
              mediaSliderKey={mediaSliderKey}
              labels={labels}
              panelRef={panelRef}
              disableRunLinks={disableRunLinks}
              customRunNames={customRunNames}
            />
          )
        )}
      </>
    );
  }
);

export default PanelTileList;
